package com.yogaaicoach.pages.payment

import com.yogaaicoach.common.ui.components.*
import com.yogaaicoach.pages.payment.ui.ManageSubscriptionViewModel
import com.yogaaicoach.pages.payment.ui.SubscriptionDetailsUiState
import com.yogaaicoach.scope
import com.yogaaicoach.user.AppViewModel
import kotlinx.coroutines.launch
import react.ChildrenBuilder
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.h2
import react.dom.html.ReactHTML.p
import react.useEffectOnce
import react.useState
import web.cssom.ClassName

internal external interface ManageSubscriptionPageProps : Props {
    var viewModel: ManageSubscriptionViewModel
    var appViewModel: AppViewModel
    var showSuccessMessage: Boolean
    var onNoSubscriptionFound: () -> Unit
    var onNavigateToDashboard: () -> Unit
    var onNavigateToPayment: () -> Unit
    var onNavigateToContactUs: () -> Unit
}

internal val ManageSubscriptionPage = FC<ManageSubscriptionPageProps> { props ->
    var isPageLoaded by useState(false)
    var isSuccessVerified by useState(false)
    var uiState by useState(SubscriptionDetailsUiState())

    useEffectOnce {
        scope.launch { props.viewModel.isPageLoadedFlow.collect { isPageLoaded = it } }
        scope.launch { props.viewModel.isSuccessVerifiedFlow.collect { isSuccessVerified = it } }
        scope.launch { props.viewModel.uiState.collect { uiState = it } }
        props.viewModel.loadPage(props.appViewModel, props.onNoSubscriptionFound)
    }

    TopBar {
        title = "Subscription"
        onSignOut = { props.appViewModel.signOut() }
        onNavigateToDashboard = props.onNavigateToDashboard
        onNavigateToPayment = props.onNavigateToPayment
        onNavigateToContactUs = props.onNavigateToContactUs
    }

    if (!isPageLoaded) {
        LoadingPage {}
        return@FC
    }

    div {
        className = ClassName("payment-page-shell")

        if (props.showSuccessMessage && isSuccessVerified) {
            div {
                className = ClassName("payment-status-message payment-status-success")
                CheckCircleIconGreen {}
                p { +"Your subscription has been activated successfully!" }
            }
        }

        h2 { className = ClassName("payment-page-title"); +"Manage Subscription" }

        when {
            uiState.isLoading -> div { className = ClassName("payment-loading-spinner") }
            uiState.error != null -> p { className = ClassName("payment-error"); +uiState.error!! }
            else -> {
                SubscriptionInfoCard(uiState)
                div {
                    className = ClassName("payment-actions")
                    button {
                        val disabled = uiState.isCancelled
                        className = ClassName("payment-cancel-button${if (disabled) " payment-cancel-button-disabled" else ""}")
                        this.disabled = disabled
                        onClick = { props.viewModel.cancelSubscription() }
                        +"Cancel Subscription"
                    }
                }
            }
        }
    }
}

private fun ChildrenBuilder.SubscriptionInfoCard(uiState: SubscriptionDetailsUiState) {
    div {
        className = ClassName("payment-info-card")
        InfoRow({ CreditCardIconPrimary {} }, "Current Plan", uiState.plan)
        InfoRow({ DateRangeIconPrimary {} }, "Next Billing Date", uiState.nextBillingDate)
        if (uiState.isCancelled) {
            div {
                className = ClassName("payment-cancelled-warning")
                WarningIconRed {}
                p { +"Your subscription is cancelled and will not renew." }
            }
        }
    }
}

private fun ChildrenBuilder.InfoRow(icon: ChildrenBuilder.() -> Unit, label: String, value: String) {
    div {
        className = ClassName("payment-info-row")
        div { className = ClassName("payment-info-icon"); icon() }
        div {
            p { className = ClassName("payment-info-label"); +label }
            p { className = ClassName("payment-info-value"); +value }
        }
    }
}
